import React, { forwardRef, PropsWithChildren } from "react";
import { ContainAspectRatioWithinSquare } from "@ff-os/shared-react/components/aspect-ratio/ContainAspectRatioWithinSquare";
import classNames from "classnames";
import {
    useMemoizedPhoto,
    useMemoizedPaintables,
    useMemoizedSpaces
} from "../../memoizations/_redux-memoization";
import { PhotoPrintPreview } from "./PhotoPrintPreview";
import styles from "./PhotoPrintFrame.module.scss";

const PhotoPrintFrameComponent = forwardRef<HTMLDivElement, PhotoPrintFrameProps>(({
    photoId, children,
    onDragStart = e => e.preventDefault(),
    onDragEnd = e => e.preventDefault(),
    onDrop,
    onDragOver,
    onDragLeave,
    disabled = false,
    className,
    hasAccessoryDraggedOver = false
}, photoRef) => {

    const photo = useMemoizedPhoto(photoId);
    const spaces = useMemoizedSpaces(photoId);
    const paintables = useMemoizedPaintables(photoId);

    return (
        <ContainAspectRatioWithinSquare
            width={spaces.sceneWidth} height={spaces.sceneHeight}
            draggable={!disabled} onDragStart={onDragStart} onDragEnd={onDragEnd}
            onDrop={onDrop} onDragOver={onDragOver} onDragLeave={onDragLeave}>
            <div className={classNames(
                styles.photo, 
                className, 
                { 
                    [styles.draggable]: !disabled,
                    [styles.accessoryDragOver]: hasAccessoryDraggedOver
                }
            )} ref={photoRef}>
                <PhotoPrintPreview photoId={photo.id} spaces={spaces} paintables={paintables} />
            </div>
            {children}
        </ContainAspectRatioWithinSquare>
    );
});

type PhotoPrintFrameProps = PropsWithChildren<{
    photoId: string;
    onDragStart?: React.DragEventHandler;
    onDragEnd?: React.DragEventHandler;
    onDrop?: React.DragEventHandler;
    onDragOver?: React.DragEventHandler;
    onDragLeave?: React.DragEventHandler;
    disabled?: boolean;
    className?: string;
    hasAccessoryDraggedOver?: boolean;
}>;

export const PhotoPrintFrame = React.memo(PhotoPrintFrameComponent);